import React from 'react';
import { Link } from 'react-router-dom';
import Eyebrow from '../motion/Eyebrow';
import KineticHeadline from '../motion/KineticHeadline';
import Reveal from '../motion/Reveal';
import Tilt from '../motion/Tilt';
import CountUp from '../motion/CountUp';
import Claws from '../motion/Claws';
import SectionLight from '../motion/SectionLight';

/** POOLS: the public Title Shot pool (gold) and private pools (red), with live counts. */
export default function PoolsSection({ stats }) {
  return (
    <section id="pools" className="pnp-section" aria-labelledby="pnp-pools-title">
      <SectionLight bleed="60px">
        <div className="pnp-octagrid" style={{ opacity: 0.6 }} />
        <div className="pnp-glow pnp-glow-gold" style={{ left: '-25%', top: '20%', opacity: 0.8 }} />
        <div className="pnp-glow" style={{ right: '-28%', top: '30%' }} />
      </SectionLight>
      <div className="pnp-wrap">
        <div className="pnp-head pnp-center">
          <Eyebrow>Two ways to play</Eyebrow>
          <div id="pnp-pools-title"><KineticHeadline text={'Chase the ^belt.^\nOr run your *own.*'} /></div>
          <Reveal delay={200}>
            <p className="pnp-lead">Both are free. Play in the public pool and as many private pools as you want, with the same picks screen for every card.</p>
          </Reveal>
        </div>

        <div className="pnp-pools-grid">
          <Reveal>
            <Tilt tone="gold">
              <article className="pnp-glass pnp-glass-gold pnp-pool-card">
                <img className="pnp-pool-belt pnp-float" src="/images/title-belt.svg" alt="" aria-hidden="true" />
                <div className="pnp-eyebrow pnp-eyebrow-gold"><span className="pnp-eyebrow-claw" aria-hidden="true"><i /><i /><i /></span><span>Public pool</span></div>
                <h3 className="pnp-display pnp-h3">The <span className="pnp-kh-gold">Title Shot</span></h3>
                <p className="pnp-body">One free pool for everyone. Pick the same card as the whole community, and whoever finishes #1 for the event takes the Title Shot belt badge.</p>
                <div className="pnp-pool-count">
                  <CountUp to={stats ? stats.public_pool_members : null} className="pnp-stat-num pnp-gold" />
                  <span className="pnp-stat-label">players in for the belt</span>
                </div>
                <Link to="/join/TITLESHOT" className="pnp-btn pnp-btn-gold">Join the Title Shot <span className="pnp-btn-arrow" aria-hidden="true">→</span></Link>
              </article>
            </Tilt>
          </Reveal>
          <Reveal delay={140}>
            <Tilt>
              <article className="pnp-glass pnp-glass-red pnp-pool-card">
                <Reveal rise={false} style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}>
                  <Claws className="pnp-pool-card-claws" />
                </Reveal>
                <div className="pnp-eyebrow"><span className="pnp-eyebrow-claw" aria-hidden="true"><i /><i /><i /></span><span>Private pools</span></div>
                <h3 className="pnp-display pnp-h3">Your crew. <span className="pnp-kh-accent">Your rules.</span></h3>
                <p className="pnp-body">Start a pool for the group chat, the gym or the office. Share the invite code, choose which fights count and how they score, and run it as commissioner.</p>
                <div className="pnp-pool-count">
                  <CountUp to={stats ? stats.private_pool_count : null} className="pnp-stat-num" />
                  <span className="pnp-stat-label">private pools running</span>
                </div>
                <Link to="/register?redirect=/create-pool" className="pnp-btn pnp-btn-primary">Start a private pool <span className="pnp-btn-arrow" aria-hidden="true">→</span></Link>
              </article>
            </Tilt>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
